import { render, staticRenderFns } from "./web1c.vue?vue&type=template&id=1d041872&scoped=true&lang=pug"
import script from "./web1c.vue?vue&type=script&lang=js"
export * from "./web1c.vue?vue&type=script&lang=js"
import style0 from "./web1c.vue?vue&type=style&index=0&id=1d041872&prod&lang=stylus"
import style1 from "./web1c.vue?vue&type=style&index=1&id=1d041872&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d041872",
  null
  
)

export default component.exports